import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { Subject } from "rxjs";

@Directive({
  selector: "[myautofocus]",
})
export class AutofocusDirective implements OnInit, AfterViewInit,OnDestroy {
  private focus = false;
  private destroy$ = new Subject<void>();
  constructor(private el: ElementRef) {}

  ngAfterViewInit() {}

  ngOnInit() {}

  @Input() set myautofocus(condition: boolean) {
    this.focus = condition !== false;
    if (this.focus) {
      window.setTimeout(() => {
        this.el.nativeElement.focus();
        this.el.nativeElement.select();
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
